module.exports = __webpack_public_path__ + "static/media/section-around-shape.c9f09f54.svg";